<template>
  <ul
    :class="{'is-active': navState}"
    class="navigation">
    <li
      class="navigation_close"
      @click="close"/>
    <li>
      <BtnLanguage/>
    </li>
    <li>
      <BtnIntroduction
        v-if="lang.key === 'JP'"/>
    </li>
    <li>
      <BtnNews/>
    </li>
    <li>
      <BtnTwitter/>
    </li>
    <li>
      <BtnFacebook/>
    </li>

  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import BtnIntroduction from '@/components/atoms/BtnIntroduction'
import BtnNews from '@/components/atoms/BtnNews'
import BtnTwitter from '@/components/atoms/BtnTwitter'
import BtnFacebook from '@/components/atoms/BtnFacebook'
import BtnLanguage from '@/components/atoms/BtnLanguage'

export default {
  name: 'Navigation',
  components: {
    mapGetters,
    BtnIntroduction,
    BtnNews,
    BtnTwitter,
    BtnFacebook,
    BtnLanguage
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['textData', 'lang', 'navState'])
  },
  methods: {
    close: function () {
      this.$store.dispatch('changeNavState')
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="postcss" scoped>
  .navigation {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 2000;
    width: 100%;
    height: 100vh;
    color: #FFFFFF;
    background: #000000;
    text-align: center;
    padding-top: 45px;
    & li {
      font-size: 0;
      margin-bottom: 20px;
    }
    &_close {
      position: absolute;
      z-index: 2500;
      top: 10px;
      left: 10px;
      width: 28px;
      height: 28px;
      padding: 5px;
    }
    &_close:before,
    &_close:after {
      content: '';
      position: absolute;
      left: 13px;
      height: 20px;
      width: 2px;
      background-color: #FFFFFF;
      border-radius: 1px;
    }
    &_close:before {
      transform: rotate(45deg);
    }
    &_close:after {
      transform: rotate(-45deg);
    }
    .btnTwitter {
      margin-bottom: 5px;
    }
  }
  .navigation.is-active {
    animation: show 0.2s ease 0s;
  }
  .navFade-leave-active {
    transition: opacity 0.2s;
  }
  .navFade-leave-to {
    opacity: 0.;
  }
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/Navigation.vue